import React from 'react';
import { ISliderOverlay } from '../../interfaces/SliderOverlay.interface';
import { Alignments } from '../../enums/alignments';
import { Icons } from '../../enums/icons';
import Icon from '../Icon/Icon';
import { Container, SliderContainer, CloseButton } from './styles';

const SliderOverlay = ({
  isVisible,
  onClick,
  alignment = Alignments.RIGHT,
  fullScreen = false,
  children
}: ISliderOverlay) => (
  <Container isVisible={isVisible} onClick={onClick} fullScreen={fullScreen} alignment={alignment}>
    <SliderContainer
      isVisible={isVisible}
      onClick={(e) => e.stopPropagation()}
      fullScreen={fullScreen}
      alignment={alignment}
    >
      <CloseButton onClick={onClick} alignment={alignment}>
        <Icon type={Icons.CLOSE} />
      </CloseButton>
      {children}
    </SliderContainer>
  </Container>
);

export default SliderOverlay;
